// extracted by mini-css-extract-plugin
export default {"product-tab-view":"ProductTabView_product-tab-view__X4sQv"};